export default __webpack_public_path__ + "static/media/GoodMannersOnThePlayground_03.2fabc66f.png";